import axios from 'axios';
import { USER_TOKEN_KEY } from '../context/AuthContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor for adding auth token (cliente en localStorage, admin en sessionStorage)
api.interceptors.request.use(
  (config) => {
    // Check for user token first, then admin token
    const userToken = localStorage.getItem(USER_TOKEN_KEY);
    const adminToken = sessionStorage.getItem('_at');
    const token = userToken || adminToken;
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for handling errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Clear tokens on auth failure
      localStorage.removeItem(USER_TOKEN_KEY);
      sessionStorage.removeItem(USER_TOKEN_KEY);
      sessionStorage.removeItem('_at');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
